/**
 * Convert the Properties from entry content into an array of objects to be used in different components
 *
 * @param data
 * @returns {[]}
 */
export default function getOverviewFilterData(filters, results, t) {
  const data = []

  if (!filters) return null

  const ageFilterData = filters.data.ageFilter
  const ageRequestData = results ? results.ageCategories : false

  const fieldSizeFilterData = filters.data.fieldSizeFilter
  const fieldSizeRequestData = results ? results.fieldSizeCategory : false

  const activityFilterData = filters.data.activityFilter
  const activityRequestData = results ? results.activities : false

  const objectiveFilterData = filters.data.objectiveFilter
  const objectiveRequestData = results ? results.objectiveCategories : false

  const playersCountFilterData = filters.data.playersCountFilter
  const playersCountRequestData = results ? results.playersCount : false

  const timesPerWeekFilterData = filters.data.timesPerWeekFilter
  const timesPerWeekRequestData = results ? results.timesPerWeekCategory : false

  const exerciseTypeFilterData = filters.data.exerciseTypeFilter
  const exerciseTypeRequestData = results ? results.exerciseTypeCategory : false

  const trainingTypeFilterData = filters.data.trainingTypeFilter
  const trainingTypeRequestData = results ? results.trainingTypeCategory : false

  const fieldTypeFilterData = filters.data.fieldTypeFilter
  const fieldTypeRequestData = results ? results.fieldTypeCategory : false

  // const programTypeFilterData = filters.data.programTypeFilter
  // const programTypeRequestData = (results) ? results.trainingTypeCategory : false

  // const trainingDurationFilterData = filters.data.trainingDurationFilter
  // const trainingDurationRequestData = (results) ? results.trainingDuration : false

  // Age Group Filter used in all three types
  if (ageFilterData) {
    const ageFilter = []
    ageFilter.name = 'ageCategories'
    ageFilter.id = 'ageFilter'
    ageFilter.title = t('FILTERDROPDOWN__AGE_LABEL')
    ageFilter.default = t('FILTERDROPDOWN__AGE_DEFAULT')
    ageFilter.options = []
    ageFilterData.map((option) => {
      const optionLabel =
        ageRequestData && ageRequestData[option.id]
          ? `${option.label} - (${ageRequestData[option.id]})`
          : `${option.label} - (0)`
      const optionDisabled = ageRequestData && !ageRequestData[option.id]

      ageFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.label,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(ageFilter)
  }

  // Training Type Filter used in trainings
  if (trainingTypeFilterData) {
    const trainingTypeFilter = []
    trainingTypeFilter.name = 'trainingTypeCategory'
    trainingTypeFilter.id = 'trainingTypeFilter'
    trainingTypeFilter.title = t('FILTERDROPDOWN__TRAININGTYPE_LABEL')
    trainingTypeFilter.default = t('FILTERDROPDOWN__TRAININGTYPE_DEFAULT')
    trainingTypeFilter.options = []
    trainingTypeFilterData.map((option) => {
      const optionLabel =
        trainingTypeRequestData && trainingTypeRequestData[option.id]
          ? `${option.title} - (${trainingTypeRequestData[option.id]})`
          : `${option.title} - (0)`
      const optionDisabled = trainingTypeRequestData && !trainingTypeRequestData[option.id]

      trainingTypeFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.title,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(trainingTypeFilter)
  }

  // Field Type Filter used in all three types
  if (fieldTypeFilterData) {
    const fieldTypeFilter = []
    fieldTypeFilter.name = 'fieldTypeCategory'
    fieldTypeFilter.id = 'fieldTypeFilter'
    fieldTypeFilter.title = t('FILTERDROPDOWN__FIELDTYPE_LABEL')
    fieldTypeFilter.default = t('FILTERDROPDOWN__FIELDTYPE_DEFAULT')
    fieldTypeFilter.options = []
    fieldTypeFilterData.map((option) => {
      const optionLabel =
        fieldTypeRequestData && fieldTypeRequestData[option.id]
          ? `${option.label} - (${fieldTypeRequestData[option.id]})`
          : `${option.label} - (0)`
      const optionDisabled = fieldTypeRequestData && !fieldTypeRequestData[option.id]

      fieldTypeFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.label,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(fieldTypeFilter)
  }

  // Field Size Filter used in all three types
  if (fieldSizeFilterData) {
    const fieldSizeFilter = []
    fieldSizeFilter.name = 'fieldSizeCategory'
    fieldSizeFilter.id = 'fieldSizeFilter'
    fieldSizeFilter.title = t('FILTERDROPDOWN__FIELDSIZE_LABEL')
    fieldSizeFilter.default = t('FILTERDROPDOWN__FIELDSIZE_DEFAULT')
    fieldSizeFilter.options = []
    fieldSizeFilterData.map((option) => {
      const optionLabel =
        fieldSizeRequestData && fieldSizeRequestData[option.id]
          ? `${option.label} - (${fieldSizeRequestData[option.id]})`
          : `${option.label} - (0)`
      const optionDisabled = fieldSizeRequestData && !fieldSizeRequestData[option.id]

      fieldSizeFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.label,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(fieldSizeFilter)
  }

  // Objective Filter used in exercises and trainings
  if (objectiveFilterData) {
    const objectiveFilter = []
    let optionGroup = ''
    objectiveFilter.name = 'objectiveCategories'
    objectiveFilter.id = 'objectiveFilter'
    objectiveFilter.title = t('FILTERDROPDOWN__OBJECTIVE_LABEL')
    objectiveFilter.default = t('FILTERDROPDOWN__OBJECTIVE_DEFAULT')
    objectiveFilter.options = []

    objectiveFilterData.map((option) => {
      let optionLabel = option.title
      let optionDisabled = true

      if (option.level === 1) optionGroup = optionLabel

      if (option.level === 2) {
        optionLabel =
          objectiveRequestData && objectiveRequestData[option.id]
            ? `${option.title} - (${objectiveRequestData[option.id]})`
            : `${option.title} - (0)`
        optionDisabled = objectiveRequestData && !objectiveRequestData[option.id]
      }

      objectiveFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.title,
        disabled: optionDisabled,
        group: optionGroup
      })
      return ''
    })
    data.push(objectiveFilter)
  }

  // Activity Filter used in exercises and trainings
  if (activityFilterData) {
    const activityFilter = []
    activityFilter.name = 'activities'
    activityFilter.id = 'activityFilter'
    activityFilter.title = t('FILTERDROPDOWN__ACTIVITY_LABEL')
    activityFilter.default = t('FILTERDROPDOWN__ACTIVITY_DEFAULT')
    activityFilter.options = []
    activityFilterData.map((option) => {
      const optionLabel =
        activityRequestData && activityRequestData[option.id]
          ? `${option.title} - (${activityRequestData[option.id]})`
          : `${option.title} - (0)`
      const optionDisabled = activityRequestData && !activityRequestData[option.id]

      activityFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.title,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(activityFilter)
  }

  // Player Count Filter used in exercises and trainings
  if (playersCountFilterData) {
    const playersCountFilter = []
    playersCountFilter.name = 'playersCount'
    playersCountFilter.id = 'playersCountFilter'
    playersCountFilter.title = t('FILTERDROPDOWN__PLAYERCOUNT_LABEL')
    playersCountFilter.default = t('FILTERDROPDOWN__PLAYERCOUNT_DEFAULT')
    playersCountFilter.options = []
    playersCountFilterData.map((option) => {
      const optionLabel =
        playersCountRequestData && playersCountRequestData[option.id]
          ? `${option.title} - (${playersCountRequestData[option.id]})`
          : `${option.title} - (0)`
      const optionDisabled = playersCountRequestData && !playersCountRequestData[option.id]

      playersCountFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.title,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(playersCountFilter)
  }
  // Times per week Filter used in programs
  if (timesPerWeekFilterData) {
    const timesPerWeekFilter = []
    timesPerWeekFilter.name = 'timesPerWeekCategory'
    timesPerWeekFilter.id = 'timesPerWeekFilter'
    timesPerWeekFilter.title = t('FILTERDROPDOWN__TIMESPERWEEK_LABEL')
    timesPerWeekFilter.default = t('FILTERDROPDOWN__TIMESPERWEEK_DEFAULT')
    timesPerWeekFilter.options = []
    timesPerWeekFilterData.map((option) => {
      const optionLabel =
        timesPerWeekRequestData && timesPerWeekRequestData[option.id]
          ? `${option.title} - (${timesPerWeekRequestData[option.id]})`
          : `${option.title} - (0)`
      const optionDisabled = timesPerWeekRequestData && !timesPerWeekRequestData[option.id]

      timesPerWeekFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.title,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(timesPerWeekFilter)
  }

  // Exercise Type Filter used in exercises
  if (exerciseTypeFilterData) {
    const exerciseTypeFilter = []
    exerciseTypeFilter.name = 'exerciseTypeCategory'
    exerciseTypeFilter.id = 'exerciseTypeFilter'
    exerciseTypeFilter.title = t('FILTERDROPDOWN__EXERCISETYPE_LABEL')
    exerciseTypeFilter.default = t('FILTERDROPDOWN__EXERCISETYPE_DEFAULT')
    exerciseTypeFilter.options = []
    exerciseTypeFilterData.map((option) => {
      const optionLabel =
        exerciseTypeRequestData && exerciseTypeRequestData[option.id]
          ? `${option.title} - (${exerciseTypeRequestData[option.id]})`
          : `${option.title} - (0)`
      const optionDisabled = exerciseTypeRequestData && !exerciseTypeRequestData[option.id]

      exerciseTypeFilter.options.push({
        value: option.id,
        label: optionLabel,
        active: option.title,
        disabled: optionDisabled
      })
      return ''
    })
    data.push(exerciseTypeFilter)
  }

  return data
}
